import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { connectMediaStore, useMMSelector, useMMDispatchActions } from './withOwnReduxStore';
import { changeCurrentMediaSource } from '../actions';
import { getCurrentMediaSource, getMediaSourceTypes, getWithMediaSourceSelector } from '../selectors';
export const useCurrentMediaSource = ()=>_object_spread({}, useMMSelector((state)=>({
            currentMediaSource: getCurrentMediaSource(state),
            mediaSourceTypes: getMediaSourceTypes(state),
            withMediaSourceSelector: getWithMediaSourceSelector(state)
        })), useMMDispatchActions({
        changeCurrentMediaSource
    }));
export default ((component)=>connectMediaStore((state, ownProps)=>({
            currentMediaSource: getCurrentMediaSource(state) || ownProps.initialMediaSource,
            mediaSourceTypes: getMediaSourceTypes(state) || ownProps.mediaSourceTypes,
            withMediaSourceSelector: getWithMediaSourceSelector(state) !== undefined ? getWithMediaSourceSelector(state) : ownProps.withMediaSourceSelector
        }), {
        changeCurrentMediaSource
    })(component)); // redux is a bit dumb with generics
